import { defineComponent as i, computed as u } from "vue";
import l from "@ado/dropdown-menu-ld";
import { submitInternalEventAndRedirectToPage as d } from "../../../shared/data/tracking/utilities/index.js";
import { TRACKING_EVENTS as m } from "../../../shared/data/tracking/types/index.js";
import { useNavigationEventBus as s } from "@ado/acs-standard-library";
import "@ado/dropdown-menu-ld/style.css";
const y = i({
  name: "MenuCategory",
  components: {
    DropdownMenu: l
  },
  props: {
    dropdownMenuItems: {
      type: Object,
      required: !1
    },
    menuType: {
      type: String,
      default: "EXPAND_ON_CLICK"
    },
    name: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    },
    hasArrowIcon: {
      type: Boolean,
      default: !1
    },
    shouldHighlight: {
      type: Boolean,
      default: !1
    },
    shouldRedirect: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const t = u(
      () => e.shouldHighlight ? "highlighted-text" : ""
    ), n = () => {
      const r = {
        ...m.PRODUCT_MENU_CATEGORY_CLICK,
        component: e.name
      };
      d(r, {
        url: e.url
      });
    }, o = () => {
      e.dropdownMenuItems?.length === 0 && n();
    }, a = s();
    return {
      menuCategoryTextAdditionalClasses: t,
      handleMenuCategoryClick: o,
      navigationEventBus: a
    };
  }
});
export {
  y as default
};
//# sourceMappingURL=index31.js.map
